import { useState, useEffect, useCallback } from 'react';
import { trackEvent } from '../utils/ga.js';

export const useTTS = (sourceLang) => {
    const [availableVoices, setAvailableVoices] = useState([]);

    useEffect(() => {
        if (!('speechSynthesis' in window)) return;

        const loadVoices = () => {
            setAvailableVoices(speechSynthesis.getVoices());
        };

        const voices = speechSynthesis.getVoices();
        if (voices.length > 0) {
            loadVoices();
        } else {
            speechSynthesis.onvoiceschanged = loadVoices;
        }

        return () => {
            speechSynthesis.onvoiceschanged = null;
        };
    }, []);

    const handleTTS = useCallback((textToSpeak) => {
        if (!textToSpeak || !('speechSynthesis' in window)) return;

        trackEvent('play_tts', { char_length: textToSpeak.length });
        speechSynthesis.cancel();

        const utterance = new SpeechSynthesisUtterance(textToSpeak);
        const targetLangCode = sourceLang === 'ko' ? 'vi-VN' : 'ko-KR';

        const voice = availableVoices.find(v => v.lang.startsWith(targetLangCode.split('-')[0]));

        if (voice) {
            utterance.voice = voice;
        } else {
            utterance.lang = targetLangCode;
        }

        utterance.rate = 0.9;
        speechSynthesis.speak(utterance);
    }, [sourceLang, availableVoices]);

    return { handleTTS };
};
